import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

export const selectUserDepartments = ({ careWorkers }: RootState) => careWorkers.userDepartments.rows;
export const selectUserDepartmentByID = createSelector(
  [selectUserDepartments, (_: RootState, id?: number) => id],
  (rows, id) => rows.find(({ id: rowId }) => id === rowId),
);
